<template>
  <b-card header="Date of Birth"
          header-bg-variant="info"
          header-text-variant="white"
  >
    <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
      <b-row>
        <b-col lg="6" >
          <b-form-group label="Date of Birth" label-for="dob">
            <date-picker v-model="form.dob" placeholder="Date (MM/DD/YYYY)" ></date-picker>
            <input-help :form="form" field="dob" text=""></input-help>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button variant="success" type="submit">Save</b-button>
        </b-col>
      </b-row>
    </form>
  </b-card>
</template>

<script>
import moment from "moment";

export default {
  props: {
    'user': {}
  },

  data() {
    return {
      form: new Form({
        dob: this.user.date_of_birth ?  moment(this.user.date_of_birth).format( 'MM/DD/YYYY' ): null,
      })
    }
  },

  methods: {
    submit() {
      this.form.submit('patch', '/profile/dob');
    },
  },
}
</script>
